import React, { Component } from 'react';
import { Container, Row, Col, Form, Button} from 'react-bootstrap';
import HtmlEditor from '../HtmlEditor/HtmlEditor'
import PropTypes from 'prop-types';

import DatePicker from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";

var storage = {}
export default class FormComponent extends Component {
    
    state = {

    }

    componentDidMount = () => {
        var store_to = this.props.store_to
        
        this.define_storage()

        if(store_to=="state"){
            this.props._this.setState(storage)
        }else{
            this.props._this.setState({
                [store_to]: storage
            })
        }
    };

    define_storage = ()=>{
        var store_to = this.props.store_to
        
        if(store_to=="state"){
            storage = this.props._this.state
        }else{
            storage = this.props._this.state && this.props._this.state[store_to] || {} 
        }
        if(!storage){

            if(this.props.store_is_array){
                storage = []
            }else{
                storage = {}
            }
            
        }
    }
    

    onChange = (e)=>{
        var value = e.target.value
        var name = e.target.name
        var store_to = this.props.store_to
        
        console.log(e)
        if(e.target.type=="checkbox"){
            value = e.target.checked
        }

        this.define_storage()
        
        if(this.props.store_is_array){
            storage[this.props.store_index][name] = value
        }else{
            storage[name] = value
        }
        
        console.log(storage)
        if(store_to=="state"){
            this.props._this.setState(storage)
        }else{
            this.props._this.setState({
                [store_to]: storage
            })
        } 
    } 

    shouldComponentUpdate(nextProps, nextState){
        if(nextProps!=this.props){
            this.define_storage()
            return true
        }  
    }

    _get_format = (type)=>{
        switch (type) {
            case 'date':
                return 'yyyy-MM-dd'
                break;
            case 'time':
                return 'HH:mm'
                break;
            case 'datetime':
                return 'yyyy-MM-dd HH:mm'
                break;
        
            default:
                break;
        }
    }

    _parse_date = (str_date)=>{
        try{
            return new Date(str_date)
        }catch{
            return new Date()
        }
    }

    onFocus = (e, f)=>{
        if(f.type=='password'){
            this.onChange({
                target:{
                    name: f.name,
                    value: ""
                }
            })
        }
    }

  render() {
    console.log(this.props)
    console.log(this.props.method === 'create')
    var existSomeValues = false
    return (
        <Form> 
            {
                this.props.fields && this.props.fields.length && this.props.fields.map((f, index)=>{
                    //console.log(storage)
                    //console.log(f.name)

                    //console.log(f.name, this.props.store_index, this.props.store_is_array)

                    var value = storage[f.name]
                    if(this.props.store_is_array){ 
                        try{
                            value = storage[this.props.store_index][f.name]
                        }catch{

                        }
                    }

                    if(value){
                        existSomeValues = true
                    }

                    if( ["datetime", "time", "date"].indexOf(f.as) != -1 ){ 
                        let zone = value ? this._parse_date(value).getTimezoneOffset()/60*-1 : new Date().getTimezoneOffset()/60*-1
                        if(zone>0){
                            zone = "+"+zone
                        }
                        return ( <div className="mt-3 mb-2">
                                <div className="">
                                    <Form.Label>{f.label} <small>(GMT { zone})</small> </Form.Label>
                                </div>
                                <DatePicker
                                    onChange={(newDate)=>{ this.onChange({target:{name: f.name, value: newDate} })} }
                                    selected={value? this._parse_date(value) : null }
                                    disabled={this.props.readonly}
                                    showTimeSelect={f.as!="date"? true : null}
                                    dateFormat={this._get_format(f.as)}
                                    className="form-control"
                                />
                            </div>  
                        )
                    }
                    {console.log(f)}
                    {console.log(f.as=="html" && (value!=undefined || this.props.method === 'create' ))}
                    {console.log(( this.props.method === 'create' ))}
                    {console.log(( value ))}
                    {console.log(( this.props ))}
                    {console.log(f)}
                    if(f.as=="html" && (value!=undefined || this.props.method === 'create' || existSomeValues) ){
                        return (<div>
                            <Form.Label>{f.label}</Form.Label>
                            <HtmlEditor
                                name={f.name}
                                value={value+""}
                                onChange={this.onChange}
                                readonly={f.readonly}
                            />
                        </div>)
                    }
                     
                    if(f.as=="checkbox"){
                        return(
                            <div className="mt-2 mb-2">
                                 
                                <Form.Check  
                                    type={"checkbox"} 
                                    name={f.name}
                                    id={f.name}
                                    label={f.label}
                                    checked={value}
                                    onChange={this.onChange}
                                    disabled={f.readonly} 
                                />
                            </div>
                        )
                    }
                    
                    return (
                        <Form.Group key={f.name+index}>
                            <Form.Label>{f.label}</Form.Label>
                            <Form.Control onFocus={(e)=>this.onFocus(e, f)} autocomplete={f.autocomplete} disabled={f.readonly} as={f.as} type={f.type} placeholder={f.label} name={f.name} value={value} onChange={this.onChange}> 
                            {
                                f.options && f.options.length && f.options.map((o,index)=>{
                                    return <option key={index} value={o.value}>{o.label}</option>
                                })
                            }
                            </Form.Control>
                            <Form.Text className="text-muted">
                                    {f.description}
                                </Form.Text>
                        </Form.Group>
                    )
                })
            } 
         
      </Form>
    );
  }
}


FormComponent.propTypes = {
    _this: PropTypes.object,
    store_to: PropTypes.string,
    method: PropTypes.string,
    fields: PropTypes.array, 
    readonly: PropTypes.bool,
    store_index: PropTypes.integer,
    store_is_array: PropTypes.intbooleger,
}

